import {
    ApiHandlerDiscreteParameter,
    replaceInChain
} from "@insite/client-framework/HandlerCreator";
import { GetProductCollectionApiV2Parameter } from "@insite/client-framework/Services/ProductServiceV2";
import { MAX_PRODUCTS_TO_COMPARE } from "@insite/client-framework/Store/Components/CompareProductsDrawer/CompareProductsDrawerSelectors";
import { chain, SetProductIdsParameter } from "@insite/client-framework/Store/Components/CompareProductsDrawer/Handlers/LoadProductsToCompare";

interface Parameter {
    id: string;
    productIds: string[];
    includeAttributeTypes?: boolean;
}

type HandlerType = ApiHandlerDiscreteParameter<Parameter, GetProductCollectionApiV2Parameter>;

export const SetProductIdsParameterExtension: HandlerType = props => {
    props.apiParameter = {
        productIds: props.parameter.productIds,
        pageSize: MAX_PRODUCTS_TO_COMPARE,
        expand: ["images", "badges", "properties"],
    };
};

replaceInChain(chain, SetProductIdsParameter, SetProductIdsParameterExtension);